// error-wrapper.component.ts
import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-error',
  template: `
    <ng-template #fieldComponent></ng-template>
    <formly-error-message [field]="field"></formly-error-message>
  `,
})
export class FormlyErrorWrapperComponent extends FieldWrapper {}
